import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ThemeStyleProvider } from './components/theme/ThemeProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { ModernHomePage } from './pages/ModernHomePage';
import CreditsPage from './pages/CreditsPage';
import CreateRafflePage from './pages/CreateRafflePage';
import PaymentValidationPage from './pages/admin/PaymentValidationPage';
import { AdminPage } from './pages/AdminPage';
import { RafflePage } from './pages/RafflePage';
import { ParticipationPage } from './pages/ParticipationPage';
import { CreatorDashboardPage } from './pages/CreatorDashboardPage';
import { RaffleDrawPage } from './pages/RaffleDrawPage';
import RafflePreviewPage from './pages/RafflePreviewPage';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="rifabr-ui-theme">
      <ThemeStyleProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<ModernHomePage />} />
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/register" element={<RegisterPage />} />
            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
            <Route path="/raffle/:id" element={<RafflePage />} />
            <Route path="/raffle/:id/participate" element={<ParticipationPage />} />
            
            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/credits"
              element={
                <ProtectedRoute>
                  <CreditsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-raffle"
              element={
                <ProtectedRoute>
                  <CreateRafflePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/payments"
              element={
                <ProtectedRoute>
                  <PaymentValidationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/creator-dashboard"
              element={
                <ProtectedRoute>
                  <CreatorDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/raffle/:id/draw"
              element={
                <ProtectedRoute>
                  <RaffleDrawPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/raffle/:id/preview"
              element={
                <ProtectedRoute>
                  <RafflePreviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-raffle/:id"
              element={
                <ProtectedRoute>
                  <CreateRafflePage />
                </ProtectedRoute>
              }
            />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </AuthProvider>
          <Toaster />
        </Router>
      </ThemeStyleProvider>
    </ThemeProvider>
  );
}

export default App;
